import React, {useEffect, useImperativeHandle, useRef, useState} from 'react';
import * as Icon from 'ubs-icons';
import {COLOR, CONSTANT, FILE} from "ubs-framework/v2/common/constant";
import UButton from "ubs-framework/v2/UButton";
import UNameJobInfo from "ubs-framework/v2/UNameJobInfo";
import UIcon from "ubs-framework/v2/UIcon";
import UCustomScrollBar from 'ubs-framework/v2/UCustomScrollBar';
import UTags from 'ubs-framework/v2/UTags';
import useUAlert from "ubs-framework/v2/UAlert";
import UPopup from "ubs-framework/v2/UPopup";
import useSocket from "../../common/hooks/useSocket";
import {useDispatch, useSelector} from "react-redux";
import {api, onLogout, sendData} from "../../../store/actions";
import {bytesToSize, Encryption, getExtension, showToastSuccess, getFileType} from "ubs-framework/v2/common/function";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import {getCookie} from "ubs-framework/v2/common/function";
import CongratulationsModal from "../interview-questions/congratulations-modal";
import {STATUS_CONST, STATUS_OPTIONS, FIELD_STATUS, PB_FILED_TYPE} from "../../../common/constant";
import {showMoreText} from "ubs-framework/v2/ShowMoreText";
import UNoDataFound from "ubs-framework/v2/UErrorPages/UNoDataFound";
import Select from "react-select";
import UInput from "ubs-framework/v2/UInput";
import UDatePicker from "ubs-framework/v2/UDatePicker";
import Validator from "simple-react-validator";
import {getKeyName, getLabelValue} from "ubs-framework/v2/common/function";
import FamilyInformation from "./components/family-information";
import UFileDownload from "ubs-framework/v2/UFileDownload";
import UFilePreview from "ubs-framework/v2/UFileView/file-preview";

const DocumentUpload = (props, ref) => {
    const alert = useUAlert();
    const familyInfoRef = useRef(null);
    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({element: (message) => <>{message}</>, autoForceUpdate: {forceUpdate}, validators: {
            pan: {
                rule: value => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value),
                message: "Allow 10 Digit AlphaNumeric Valid PAN Number e.g. AAAPZ1234C. (First 5 Capital Alphabet Characters, 4 Numbers, Last 1 Capital Alphabet Character)"
            },
            aadhaar: {
                rule: value => /^\d{12}$/.test(value),
                message: "Allow 12 Digit Valid Aadhaar Number (UID) e.g. 123456789012. (Alphabets, Dots, Spaces, or Special Characters are not allowed)"
            },
            passport: {
                rule: value => /^[A-Za-z][0-9]{7}$/.test(value),
                message: "Allow 8 Character Valid Passport Number e.g. A1234567. (1 Letter followed by 7 Digits)"
            },
            voterId: {
                rule: value => /^[A-Za-z]{3}[0-9]{7}$/.test(value),
                message: "Allow 10 Character Valid Voter ID Number e.g. ABC1234567. (3 Letters followed by 7 Digits)"
            },
        }}));

    const DISPATCH = useDispatch();
    const _ORG_ID = useSelector(e => e.common.orgId);
    const _USER = useSelector(e => e.common._user);
    const _USERS = useSelector(e => e?.ats?.userObj || {});
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const _PBS = useSelector(e => e.common.preBoardingStatus);
    const _FSL = useSelector(e => e?.common?.settings?.maxFileSizeLimit);
    const _SOCKET_ID = useSelector(e => e.common.socketId);
    const _OWN = useSelector(e => e?.common?.owner);

    const [allValues, setAllValues] = useState({});
    const [allValuesBackup, setAllValuesBackUp] = useState({});
    const [allData, setAllData] = useState({
        preBoardingId: "",
        recruiterUser: "",
        recruiterPhone: "",
        fields: [
            // {
            //     "name": "Aadhaar Card (UID)",
            //     "value": "aadhaarcard(uid)",
            //     "status": 1,
            //     "type": 5,
            //     "isDefault": true,
            //     "proofType": "6757c0af371b689cc0a976c5",
            //     "isNumber": false
            //     "fieldValue": "" // this key added from front side
            // }
        ]
    });

    const [stateOptions, setStateOptions] = useState(null);
    const [countryOptions, setCountryOptions] = useState(null);
    const [allDoc, setAllDoc] = useState([
        // {
        //     proofId:""
        //     name:"",
        //     file:"",
        //      value: ""
        //      isNumber : Boolean
        // }
    ]);

    const [allDocBackup, setAllDocBackup] = useState([]);
    const [showThankYou, setShowThankYou] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(true);
    const [isChange, setIsChange] = useState(false);
    const [isFamilyChange, setIsFamilyChange] = useState(true);
    const [previewFile, setPreviewFile] = useState(null);

    useEffect(()=> {
        on()
        sendData('hrms|master|relationship|read',{currentPage:1 , limit:100 });
        sendData('addressParams', {});
        return ()=> off()
    },[]);

    useEffect(() => {
        if (allValues?.country || allValues?.country?.value) {
            sendData("addressParams", {country: allValues?.country?.value || allValues?.country})
        }
    }, [allValues?.country])

    useEffect(() => {
        const BackupValueArr = allDocBackup?.map(_ => _?.value);
        const BackupDocName = allDocBackup?.map(_ => _?.docName);
        const valueArr = allDoc?.map(_ => _?.value);
        const DocName = allDoc?.map(_ => _?.docName);

        // Check if either value or docName has changed
        const isDocNumberChange = JSON.stringify(BackupValueArr) === JSON.stringify(valueArr);
        const isDocNameSame = JSON.stringify(BackupDocName) === JSON.stringify(DocName);
        setIsChange(!(isDocNumberChange && isDocNameSame));

        /** To track Fields input is change or not EX:- First Name, Last Name*/
        const isFieldsChange = JSON.stringify(allValues) === JSON.stringify(allValuesBackup);

        /** To track Files is change or not EX:- file uploaded or file Remove*/
        let allFilesUploaded = allDoc?.every(_=> _?.file?.url) // All Files Are Uploaded
        let newFileAdded = allDoc?.some(_=> _?.file?.name && _?.file?.lastModified) // one new file added
        setDisable((isFieldsChange && isDocNumberChange && allFilesUploaded && isFamilyChange && isDocNameSame));

        if(props?.isRecruiterSide){
            props?.setDisable(isFieldsChange && isDocNumberChange && isDocNameSame && !newFileAdded && isFamilyChange)
        }

    },[allDoc,allDocBackup, allValues, allValuesBackup, isFamilyChange])


    const {on, off} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|pre|boarding|proofDocument|fetch':
                    if(Array?.isArray(res?.data?.result?.files)){
                        /**
                         * status -0 : document not uploaded.
                         * status -1 : document submitted but not approved by HR
                         * status -2 : document submitted and approved by HR
                         * status -3 : document submitted and Rejected by HR
                         * We only show rejected candidate,
                         * */

                        const findUser = [];

                        res.data.result.files = res?.data?.result?.files?.map(key => {
                            return ({ ...key || {} ,
                                status : key?.status ,
                                proofId: key?.proofType,
                                name : key?.proofTypeName || "",
                                file : key?.file || null ,
                                docName: key?.name || '',
                                [key?.proofType] : {...key?.file || {} ,
                                name : key?.file?.fileName || null } || null
                            });
                        })

                        let fields = res?.data?.result?.defaultField?.filter(_ => ([FIELD_STATUS.MANDATORY, FIELD_STATUS.OPTIONAL]?.includes(_?.status) && ![PB_FILED_TYPE.FILE]?.includes(_?.type))); // 1. mandatory, 2, Optional , | type = 5 document Number Input
                        fields = fields?.filter(_ =>  _?.type !== PB_FILED_TYPE.ARR_OF_OBJ && _?.value !== 'familyInfo'); // Remove Family Info From it
                        fields = fields.sort((a, b) => {
                            const hasProofTypeA = a.hasOwnProperty('proofType');
                            const hasProofTypeB = b.hasOwnProperty('proofType');
                            return hasProofTypeA - hasProofTypeB; // False (0) comes before True (1)
                        });
                        setAllDoc(res?.data?.result?.files?.map(_ => ({..._, ...(_?.value ? {value: _.value} : {value: ""}), ...(_?.docName ? {docName: _.docName} : {docName: ""})})));
                        setAllDocBackup(res?.data?.result?.files?.map(_ => ({..._, ...(_?.value ? {value: _.value} : {value: ""}), ...(_?.docName ? {docName: _.docName} : {docName: ""})})));
                        setAllData(prev => ({
                            ...prev,
                            preBoardingId: res?.data?.result?.files[0]?.preBoardingId,
                            recruiterPhone: res?.data?.result?.recruiterInfo?.recruiterPhone,
                            recruiterUser: res?.data?.result?.recruiterInfo?.recruiterUser,
                            recruiterEmail: res?.data?.result?.recruiterInfo?.recruiterEmail,
                            fields
                        }));

                        if (fields?.length) {
                            setAllValues(prev => {
                                /**
                                 * Prepares the Object from Fields Array Of Objects Coming From backend
                                 * */
                                prev = {};
                                if (fields?.length) fields?.map(_ => {
                                    if (_?.value) prev[_?.value] = "";
                                });
                                prev = {...prev, ...(Object?.keys(res?.data?.result?.fields || {})?.length && res?.data?.result?.fields)};
                                return prev;
                            });
                            setAllValuesBackUp(prev => {
                                /**
                                 * Prepares the Object from Fields Array Of Objects Coming From backend
                                 * */
                                prev = {};
                                if (fields?.length) fields?.map(_ => {
                                    if (_?.value) prev[_?.value] = "";
                                });
                                prev = {...prev, ...(Object?.keys(res?.data?.result?.fields || {})?.length && res?.data?.result?.fields)};
                                return prev;
                            });
                        }
                        if (res?.data?.result?.recruiterInfo?.recruiterUser) findUser?.push(res?.data?.result?.recruiterInfo?.recruiterUser)
                        if (findUser?.length !== 0) DISPATCH({type: 'FIND_MASTER_DATA_LIST', payload: {findUserIdsList: [...new Set(findUser)]}});
                    }
                    setIsFamilyChange(true)
                    break
                case "ats|pre|boarding|proofDocuments|file|delete" : {
                    showToastSuccess("Attachment deleted Successfully !");
                    break;
                }
                case 'addressParams': {
                    if (res?.data?.results?.length) {
                        if (res.data?.type === 'country') {
                            const countryList = getLabelValue(res?.data?.results);
                            setCountryOptions(countryList);
                            setAllValues(_ => ({..._, country: countryList?.find(v => v?.value === _?.country) || null}));
                            setAllValuesBackUp(_ => ({..._, country: countryList?.find(v => v?.value === _?.country) || null}));
                        } else {
                            const provinceList = getLabelValue(res?.data?.results)
                            setStateOptions(provinceList);
                            setAllValues(_ => ({..._, province: provinceList?.find(v => (v?.value === _?.province) || (v?.value === _?.province?.value)) || null}));
                            setAllValuesBackUp(_ => ({..._, province: provinceList?.find(v => (v?.value === _?.province) || (v?.value === _?.province?.value)) || null}));
                        }
                    }
                    break;
                }
                case 'ats|pre|boarding|user|updateBasicInfo': {
                    sendData('hrms|master|relationship|read',{ currentPage: 1, limit : 100});
                    showToastSuccess("Data updated Successfully !");
                    setLoading(false);
                    props?.setLoadingData ? props?.setLoadingData(false) : null;
                    break;
                }
                case 'hrms|master|relationship|read' :
                    sendData('ats|pre|boarding|proofDocument|fetch',{user: _USER?.value || props?.userId});
                    if(res?.data?.result) DISPATCH({type : "SET_FAMILY_INFO_LIST", payload : getLabelValue(res?.data?.result)})
                    break;
                default:
                    return true;
            }
        }
    });

    const handle ={
        file: (e, name) => {
            prepareFiles({[name]: e.target.files}, name)?.then()
            e.target.value = '';
        },
        documentNumber: (e, index, name) => {
            setAllDoc(prev => {
                return prev?.map((file, ind) => {
                    if(index === ind){
                        file[name] = e?.target?.value;
                        return file;
                    }else  return file;
                })
            });
        },
        removeResume: (index, proofId) => {
            alert.show({
                title: `Delete Attachment`,
                description: `Are you sure you want to delete this Attachment?`,
                icon: <Icon.Delete fill={COLOR.u_red} size={30}/>,
                onSubmit: () => {
                    let allDocLocal = [...allDoc];
                    let removedFileId = allDocLocal?.find(doc => ([doc?.proofId, doc?.proofType]?.includes(proofId)));
                    if (removedFileId && props?.isRecruiterSide && removedFileId?.proofType && removedFileId?._id && removedFileId?.file?.url){
                        let data = {
                            proofType: removedFileId?.proofType,
                            user: props?.userId,
                            preBoardingId: props?.preBoardingId,
                            _id: removedFileId?._id,
                        }
                        sendData("ats|pre|boarding|proofDocuments|file|delete", data);
                    }
                    allDocLocal[index] = {proofId: allDocLocal[index]?.proofId, name: allDocLocal[index]?.name, file: null, [proofId]: null,  isNumber: removedFileId?.isNumber, value: null,}
                    setAllDoc(prev => ([...allDocLocal]));
                }
            })
        },
        logOut:()=>{
            alert.show({
                title: `Want to Logout?`,
                description: `Are you sure you want to logout?`,
                icon: <Icon.Delete fill={COLOR.u_red} size={30}/>,
                onSubmit: () => {
                    onLogout(true, _ORG_ID)
                }
            })

        },
        changeCandidate: (e, key, data) => {
            let updatedValues = { ...allValues, [key]: e };
            if (key === "country") {
                updatedValues.province = e && e === allValues?.country ? allValues.province : "";
            }else if (key === "expectedCtcType" && [1, 2]?.includes(e)) {
                updatedValues.salaryRangeFrom = null
                updatedValues.salaryRangeTo = null
                validator.current.fields = {};
            }
            if(data?.type === 7) updatedValues = { ...allValues, [key]: new Date(e)?.getTime() };
            if(data?.type === 5) {
                updatedValues = { ...allValues, [key]: e };
            }
            setAllValues(updatedValues);
        },
        save :() => {
            if ((!allDoc?.some( _=> _?.file === null) && !allDoc?.every( _=> _?.file?.url)) && validator?.current?.allValid()) {
                /**
                 * File Uploading when New File Attached
                 * **/
                setLoading(true);
                let payload = {};
                let fileList = {};
                if(!!allDoc?.length){
                    allDoc?.filter(_ => !_?.file?.url)?.map( (item, index) => {
                        if(item?.status !== 2){
                            /**
                             * For new document uploaded status key will be not available in "item", so condition will be true
                             * this if condition is applied when document rejected by Recruiter and candidate resubmit new document
                             * */
                            const lastModified = item.file?.lastModified || new Date().getTime();
                            const stableFile = new File([item?.file], item?.file.name, {
                                type: item.file?.type,
                                lastModified: lastModified
                            });
                            payload[item?.proofId] = {
                                size:item?.file.size,
                                fileName:item?.file.name,
                                mimeType:item?.file.type,
                                lastModified: lastModified,
                                value: item?.value,
                                name: item?.docName,
                            }
                            fileList[item?.proofId] = stableFile;
                        }
                    })
                }else return 0;

                const body = {
                    event: 'ats|pre|boarding|proofDocument|update',
                    data: {
                        payload: payload,
                        orgId: _ORG_ID,
                        user: _USER?._id,
                        owner:_OWN,
                        preBoardingId: allData?.preBoardingId,
                        proofDocument: allDoc?.filter(_ => _?.isNumber)?.map(file => {
                            let stableFile =  fileList[file?.proofId] || {};
                            return ({_id: file?._id, value: file?.value, name: file?.docName,proofType: file?.proofType, ...stableFile})
                        })
                    },
                    socketId: _SOCKET_ID
                }
                const formData = new FormData();
                formData.append('body', Encryption(body));

                for (let key in fileList) {
                    formData.append(key, fileList[key]);
                }

                const config = {
                    headers: {'Authorization': `Bearer ${getCookie('ubs_token')}`},
                    onUploadProgress: e => {
                        let per = parseInt(e.loaded / e.total * 100);
                        per = per === 100 ? 99 : per;
                    },
                };

                console.log("=====>> body ===========",body)
                api.post('/fileupload', formData, config).then(response => { //fileUpload , hrmsFileUpload
                    let data = {
                        ...allValues,
                        user: _USER?._id,
                        ...(allValues?.country && {country: allValues?.country?.value || allValues?.country}),
                        ...(allValues?.province && {province: allValues?.province?.value || allValues?.province}),
                        ...(familyInfoRef?.current?.getFamilyInfo() || {}),
                    };
                    delete data.location;
                    sendData("ats|pre|boarding|user|updateBasicInfo", data)
                    // setShowThankYou(true)
                })?.catch(error => {
                    const res = error?.response
                    if (res && res.status === 400) {
                        alert.show({
                            title: 'Something went wrong.',
                            icon: <Icon.Warning fill={COLOR.u_red} size={30}/>,
                            description: res?.data?.err || res?.data?.error || res?.data?.message
                        })
                    }
                    setLoading(false)
                })
            }else if(allDoc?.length && allDoc?.every( _ => _?.file?.url) && validator?.current?.allValid()){
                /**
                 * file is Not uploaded, but Document Number will be added or updated
                 * */
                setLoading(true);
                if(isChange){
                    let data = {
                        user: _USER?._id,
                        preBoardingId: allData?.preBoardingId,
                        proofDocument: allDoc?.filter(_ => _?.isNumber)?.map(file => ({_id: file?._id, value: file?.value, name: file?.docName, proofType: file?.proofType})),
                    };
                    sendData('ats|pre|boarding|proofDocument|update', data);
                }

                let updateBasicInfo = {
                    ...allValues,
                    user: _USER?._id,
                    ...(allValues?.country && {country: allValues?.country?.value || allValues?.country}),
                    ...(allValues?.province && {province: allValues?.province?.value || allValues?.province}),
                    ...(familyInfoRef?.current?.getFamilyInfo() || {}),
                };
                delete updateBasicInfo.location;
                sendData("ats|pre|boarding|user|updateBasicInfo", updateBasicInfo)
            } else{
                /** Show validation */
                validator?.current?.showMessages()
                if (allDoc?.some( _ => !_?.file)) {
                    alert.show({
                        title: 'Required.',
                        icon: <Icon.Warning fill={COLOR.u_red} size={30}/>,
                        description: 'All documents are mandatory!'
                    })
                }
            }
        },
        saveRecruiter :()=>{

            let newFileAdded = allDoc?.some(_=> _?.file?.name && _?.file?.lastModified) // one new file added

            if(newFileAdded && validator?.current?.allValid()){
                /**
                 * File Uploading when New File Attached
                 * **/
                setLoading(true);
                let payload = {};
                let fileList = {};

                if(!!allDoc?.length){
                    allDoc?.filter(_ => !_?.file?.url && _?.file)?.map((item, index) => {
                        if(item?.status !== 2){
                            const lastModified = item.lastModified || new Date().getTime();
                            const stableFile = new File([item?.file], item?.file.name, {
                                type: item.file?.type,
                                lastModified: lastModified
                            });
                            payload[item?.proofId] ={
                                size:item?.file.size,
                                fileName:item?.file.name,
                                mimeType:item?.file.type,
                                lastModified: lastModified,
                                value: item?.value,
                                name: item?.docName,
                            }
                            fileList[item?.proofId] = stableFile;
                        }
                    })
                }

                const body = {
                    event: 'ats|pre|boarding|proofDocument|update',
                    data: {
                        payload: payload,
                        orgId: _ORG_ID,
                        user: props?.userId,
                        owner:_OWN,
                        preBoardingId: allData?.preBoardingId,
                        isAdmin :true,
                        proofDocument: allDoc?.filter(_ => _?.isNumber)?.map(file => {
                            let stableFile =  fileList[file?.proofId] || {};
                            return ({_id: file?._id, value: file?.value, name: file?.docName,proofType: file?.proofType, ...stableFile})
                        })
                    },
                    socketId: _SOCKET_ID
                }

                console.log("=====>> body ===========",body)
                const formData = new FormData();
                formData.append('body', Encryption(body));

                if(!!allDoc?.length){
                    allDoc?.filter(_ => _?.file)?.map( (item, index)=>{
                        formData.append(item?.proofId, item?.file);
                    })
                }

                for (let key in fileList) {
                    formData.append(key, fileList[key]);
                }

                const config = {
                    headers: {'Authorization': `Bearer ${getCookie('ubs_token')}`},
                    onUploadProgress: e => {
                        let per = parseInt(e.loaded / e.total * 100);
                        per = per === 100 ? 99 : per;
                        props?.setLoadingData(true)
                    },
                };

                api.post('/fileupload', formData, config).then(response => { //fileUpload , hrmsFileUpload
                    let data = {
                        ...allValues,
                        user: props?.userId,
                        isAdmin: true,
                        ...(allValues?.country && {country: allValues?.country?.value || allValues?.country}),
                        ...(allValues?.province && {province: allValues?.province?.value || allValues?.province}),
                        ...(familyInfoRef?.current?.getFamilyInfo() || {}),
                    };
                    delete data.location;
                    sendData("ats|pre|boarding|user|updateBasicInfo", data)
                }).catch(error => {
                    const res = error?.response
                    if (res && res.status === 400) {
                        setLoading(false)
                        alert.show({
                            icon: <Icon.Warning size={30} fill={COLOR.u_red}/>,
                            title: 'Something went wrong.',
                            description: res?.data?.err || res?.data?.error || res?.data?.message
                        })
                    }
                })
            }else if(validator?.current?.allValid()){
                /**
                 * file is Not uploaded, but Document Number will be added or updated
                 * */
                props?.setLoadingData(true)
                if(isChange){
                    let data = {
                        isAdmin: true,
                        user: props?.userId,
                        preBoardingId: allData?.preBoardingId,
                        proofDocument: allDoc?.filter(_ => _?.isNumber)?.map(file => ({_id: file?._id, value: file?.value, name: file?.docName,proofType: file?.proofType}))
                    };
                    sendData('ats|pre|boarding|proofDocument|update', data);
                }

                let updateBasicInfo = {
                    ...allValues,
                    isAdmin: true,
                    user: props?.userId,
                    ...(allValues?.country && {country: allValues?.country?.value || allValues?.country}),
                    ...(allValues?.province && {province: allValues?.province?.value || allValues?.province}),
                    ...(familyInfoRef?.current?.getFamilyInfo() || {}),
                };
                delete updateBasicInfo.location;
                sendData("ats|pre|boarding|user|updateBasicInfo", updateBasicInfo)
            } else {
                /** Show validation */
                validator?.current?.showMessages();
            }
        },
        getOptionValue : (value) => {
            switch (value) {
                case 'gender': return CONSTANT.GENDER_LIST;
                case 'country': return countryOptions;
                case 'province': return stateOptions;
                case 'maritalStatus': return CONSTANT.MARITAL_STATUS_LIST;
                default: return [];
            }
        },
        chekProofType: (item) => {
            if (/\b(aadhaar|adhar|adhaar|aadhar)\b/i?.test(item?.name)) {
                return {isAadharCard: true}
            } else if (/PAN/i?.test(item?.name)) {
                return {isPANCard: true}
            } else if (/Passport/i?.test(item?.name)) {
                return {isPassport: true}
            } else if (/Voter/i?.test(item?.name)) {
                return {isVoterId: true}
            }
            return null;
        },
        clear: (name) => {
            delete validator.current.errorMessages[name]
            validator.current.fields[name] = true
        },
    }

    /** File Upload */
    const prepareFiles = (data, docsName) => {

        if (data?.[docsName]?.length <= 3) {
            let sizeError = false;
            const fileArray = Object.assign([], data?.[docsName]);

            for (let i = 0; i < fileArray.length; i++) {
                if (!sizeError) sizeError = fileArray[i].size / 1024 / 1024 > _FSL;
            }
            if (!sizeError) {
                const number = data?.[docsName].length;
                for (let i = 0; i < number; i++) {
                    const name = fileArray[i]?.name?.split('.');
                    const ext = name[name.length - 1];
                    if (FILE.IMAGES.exec(fileArray[i]?.name) || FILE.DOCS.exec(fileArray[i]?.name)) {
                        if (!FILE.EXCLUDES.includes(ext)) {
                            isThisAFile(fileArray[i])?.then(validFile => {
                                if(allDoc?.find( _ => _?.proofId === docsName)){
                                    let allDocLocal = allDoc;
                                    allDocLocal[allDoc?.findIndex( _ => _?.proofId === docsName)] = {...allDocLocal[allDoc?.findIndex( _ => _?.proofId === docsName)], [docsName]:validFile, file: validFile}
                                    setAllDoc( prev => ([...allDocLocal]));
                                }
                            })
                        }
                    } else {
                        alert.show({title: 'Something went wrong.', description: `Unsupported File.`})
                    }
                }
            } else {
                alert.show({title: 'Something went wrong.', description: `Files must smaller than ${_FSL}MB!`})
            }
        } else {
            alert.show({title: 'Something went wrong.', description: 'You can only upload max three files.'})
        }
    };

    const isThisAFile = (maybeFile) => {
        return new Promise(function (resolve, reject) {
            if (maybeFile.type !== '') {
                return resolve(maybeFile);
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                if (reader.error && reader.error.name === 'NotFoundError') {
                    return reject(reader.error.name);
                }
                resolve(maybeFile);
            };
            reader.readAsBinaryString(maybeFile);
        });
    };

    useImperativeHandle(ref, () => {
        return {
            saveRecruiter: handle?.saveRecruiter,
        }
    });

    const isDisable = React.useMemo(() => {
        return (props?.isDisabled || STATUS_CONST?.READY_TO_OFFER === _PBS || STATUS_CONST?.DOCUMENTS_VERIFIED === _PBS)
    }, [props?.isDisabled, _PBS]);

    return (
        <React.Fragment>
            <div className={'u_welcome-preview-wrp u_h-full'}>
            {!props?.isRecruiterSide &&
                <div className="u_welcome-preview">
                <div className={`u_project-header u_flex u_align-center u_content-between`} id="u_project-header">

                    <div className="u_header-breadcrumb-wpr u_flex u_align-center">
                        {!!allDoc?.length && <div className={'u_small-font u_mb-10 u_mt-5 u_text-bold'}>{`Hello ${_USER?.name || ""}, Congratulations! You are step away, Please complete this process.`}</div>}
                    </div>
                    <div className="u_header-options u_flex u_align-center u_content-end u_flex-wrap ">
                        {!!allDoc?.length &&
                        <div className="u_flex u_align-center">
                            <UPopup params={{className: "u_tooltip u_tooltip-full", on: ['hover']}} desc={<span className='u_text-c'>Need Help ? </span>}>
                            <span>
                                   <UNameJobInfo
                                       avatar={<UIcon color={COLOR.u_blue} thumb={40} icon={<Icon.User size={16}/>}/>}
                                       name={<div className={"u_font-12 u_text-bold"}>{_USERS[allData?.recruiterUser]?.name || ""}</div>}
                                       job={<div className={`u_font-12 u_text-bold`}>{allData?.recruiterEmail || ""}</div>}
                                       className="u_mr-10"
                                   />
                            </span>
                            </UPopup>
                        </div>}
                        {allData?.recruiterPhone &&
                        <div className="u_flex u_align-center u_mr-10">
                            <UIcon color={COLOR.u_blue} thumb={40} icon={<Icon.Contact size={16}/>}/>
                            <div className={"u_font-12 u_text-bold u_ml-10"}>{allData?.recruiterPhone || ""}</div>
                        </div>}

                        <div className="u_flex u_align-center">
                            <UButton variant="white" disabled={loading} type="Logout" cn="u_next-btn u_mr-10 u_welcome-btn" onClick={() => {handle?.logOut()}} />
                            <UButton  variant="blue"
                                      loading={loading}
                                      disabled={disable}
                                      title="Submit Documents" type='Submit Documents' cn="u_welcome-btn" onClick={()=> handle.save()} />
                        </div>
                    </div>
                </div>
                </div>
            }
                <div className={`u_layout-list u_portal ${props?.isRecruiterSide ? "u_portal-recruiter" : 'u_portal-candidate'}`} >
                    <UCustomScrollBar>
                        <div className="u_portal-body  u_h-full">
                            <div className="u_portal-body-documents  u_border-right ">

                                <div className={`u_row u_p-16`}>
                                    <div className="u_col-12 u_content-subheader small u_mb-20">
                                        <h5>Basic Information </h5>
                                    </div>

                                    {
                                    allData?.fields && allData?.fields?.map((fields, i) => {
                                        let optionValue = handle?.getOptionValue(fields?.value);
                                        // if(props?.isRecruiterSide && fields.status === 1) fields.status = 2; // When Recruiter submit document on behalf of candidate no validation will apply
                                        if(props?.isRecruiterSide && fields.status === FIELD_STATUS.MANDATORY) fields.status = FIELD_STATUS.OPTIONAL; // When Recruiter submit document on behalf of candidate no validation will apply
                                        return fields?.status !== FIELD_STATUS.OFF &&
                                        <React.Fragment key={fields?.value || `allData${i}`}>
                                            {/** Text Field  && Type - 5 :- Document Number Collection*/}
                                            {([PB_FILED_TYPE.TEXT, PB_FILED_TYPE.FILE]?.includes(fields?.type)) && <div className="u_col-4 u_mb-15">
                                                <UInput label={fields?.name} asterisk={fields?.status === FIELD_STATUS.MANDATORY}
                                                        hasError={fields?.status === FIELD_STATUS.MANDATORY && validator.current.message(fields?.value, allValues?.[fields?.value], 'required')}>
                                                    <input type="text" name={fields?.value} placeholder=" " value={allValues?.[fields?.value]}
                                                           disabled={isDisable}
                                                           autoComplete="off" onChange={e => handle.changeCandidate(e?.target?.value, fields?.value ,fields)}/>
                                                </UInput>
                                            </div>}

                                            {/** Email Field */}
                                            {fields?.type === PB_FILED_TYPE.EMAIL && <div className="u_col-4 u_mb-15">
                                                <UInput label={fields?.name} asterisk={fields?.status === FIELD_STATUS.MANDATORY}
                                                        hasError={fields?.status === FIELD_STATUS.MANDATORY && validator.current.message(fields?.value, allValues?.[fields?.value], 'required|email')}>
                                                    <input type="text" name={fields?.value} placeholder=" " value={allValues?.[fields?.value]} disabled={isDisable}
                                                           autoComplete="off" onChange={e => handle.changeCandidate(e?.target?.value, fields?.value)}
                                                           onBlur={e => handle.blurEve(e?.target?.value, fields?.value)}/>
                                                </UInput>
                                                {fields?.value === 'email' && error?.emailErr &&
                                                <p className="u_color-red u_small-font u_mt-5">{error?.emailErr}</p>
                                                }
                                            </div>}

                                            {fields?.value === 'email' && !!getRemark?.length && (allValues?.contactNo !== '' || allValues?.email !== '') &&
                                            <div className={`u_col-4 u_mb-15 u_remarks u_flex-align ${isDisable ? 'u_disable' : ''}`}>
                                                <span className="u_ib">
                                                    <UTags
                                                        className="u_flex-align u_flex-row-reverse"
                                                        icon={<Icon.UserStar size={16} fill={COLOR.u_purple}/>}
                                                        title={`This candidate received ${getRemark?.length} Remarks`}
                                                        color={COLOR.u_purple}
                                                        length={1500}
                                                    />
                                                </span>
                                                <p className="u_remarks-view u_color-blue u_ml-5 u_small-font u_flex-align" onClick={() => handle.openRemark(allValues)}>View Remarks
                                                    <span className="u_ml-5"><Icon.ArrowLeftLine size={16} fill={COLOR.u_blue}/></span>
                                                </p>
                                            </div>}
                                            {/** Number Field */}
                                            {fields?.type === PB_FILED_TYPE.NUMBER && <div className="u_col-4 u_mb-15">
                                                <UInput
                                                    label={[2, 3].includes(allValues?.salaryType) && ['currentCtc'].includes(fields?.value) ? getFieldName(fields?.value) : fields?.name}
                                                    asterisk={fields?.status === FIELD_STATUS.MANDATORY}
                                                    notice={fields?.value === 'currentCtc'}
                                                    note={(fields?.value === 'currentCtc') && `Accept number format only.<br/>ex: 10500`}
                                                    hasError={fields?.status === FIELD_STATUS.MANDATORY && validator.current.message(fields?.value, allValues?.[fields?.value], fields?.value === 'contactNo' ? 'required|min:10|max:12' : 'required')}>
                                                    <input type="number" name={fields?.value} placeholder=" " value={allValues?.[fields?.value]} disabled={isDisable}
                                                           onKeyDown={e => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()} onWheelCapture={e => e.target.blur()}
                                                           autoComplete="off" onChange={e => handle.changeCandidate(e?.target?.value, fields?.value)}
                                                           onBlur={e => handle.blurEve(e?.target?.value, fields?.value)}/>
                                                </UInput>
                                                {fields?.value === 'contactNo' && error?.contactNoErr &&
                                                <p className="u_color-red u_small-font u_mt-5">{error?.contactNoErr}</p>
                                                }
                                            </div>}
                                            {/** DropDown Field */}
                                            {fields?.type === PB_FILED_TYPE.DROPDOWN && <div className="u_col-4 u_mb-15">
                                                <UInput label={fields?.name} asterisk={fields?.status === FIELD_STATUS.MANDATORY} select selectValue={allValues?.[fields?.value] || null}
                                                        hasError={fields?.status === FIELD_STATUS.MANDATORY && validator.current.message(fields?.value, allValues?.[fields?.value], 'required')}>
                                                    <Select
                                                        name="type"
                                                        className="u_input-select-inner"
                                                        placeholder={''}
                                                        classNamePrefix="u_select"
                                                        options={optionValue}
                                                        onChange={(e) => handle?.changeCandidate(e?.value, fields?.value)}
                                                        value={(!allValues?.[fields?.value]?.length) ? allValues?.[fields?.value] : getKeyName(optionValue, allValues?.[fields?.value])}
                                                        isDisabled={isDisable ? true : (fields?.value === 'jobTitle') || (fields?.value === "province" ? !allValues?.country : false)}
                                                        isClearable={["province", "country", 'maritalStatus']?.includes(fields?.value)}
                                                    />
                                                </UInput>
                                            </div>}

                                            {/** DAe picker Field */}
                                            {fields?.type === PB_FILED_TYPE.DATE && <div className="u_col-4 u_mb-15">
                                                <UInput label={fields?.name} asterisk={fields?.status === FIELD_STATUS.MANDATORY} datepicker selectDate={allValues?.[fields?.value]}
                                                        hasError={fields?.status === FIELD_STATUS.MANDATORY && validator.current.message(fields?.value, (allValues?.[fields?.value] ? new Date(allValues?.[fields?.value]) : null), 'required')}>
                                                    <UDatePicker
                                                        disabled={isDisable}
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText=" "
                                                        maxDate={fields?.value === 'dob' ? new Date() : null}
                                                        minDate={fields?.value === 'joiningDate' ? new Date() : null}
                                                        onChange={(e) => handle.changeCandidate(e, fields?.value, fields)}
                                                        selected={allValues?.[fields?.value] ? new Date(allValues?.[fields?.value]) : null}
                                                        showDisabledMonthNavigation
                                                        popperPlacement="bottom-start"
                                                    />
                                                </UInput>
                                            </div>}
                                        </React.Fragment>
                                    })}
                                </div>

                                <FamilyInformation
                                    ref={familyInfoRef}
                                    validator={validator}
                                    maritalStatus={allValues?.maritalStatus}
                                    setDisable={setDisable}
                                    disabled={isDisable}
                                    setIsFamilyChange={setIsFamilyChange}
                                    isRecruiterSide={props?.isRecruiterSide}
                                />
                                <div className={`u_row u_px-15 u_pb-15 u_h-full`}>
                                    <div className="u_col-12 u_content-subheader small u_mb-20">
                                        <h5>Document Attachment </h5>
                                    </div>
                                    {!!allDoc?.length ? allDoc?.map( (item, i)=>{
                                        item.statusLocal = STATUS_OPTIONS?.find(_ => _?.value === item?.status);
                                        if(item?.isNumber){
                                            const proofIdentity = handle?.chekProofType(item)
                                            if(proofIdentity){
                                                const {isPANCard, isAadharCard, isPassport, isVoterId} = proofIdentity || {};
                                                item.isPANCard = isPANCard;
                                                item.isAadharCard = isAadharCard;
                                                item.isPassport = isPassport;
                                                item.isVoterId = isVoterId;
                                            }
                                        }
                                        return(
                                            <div className="u_col-4 u_mb-20" key={item?._id || `allDoc${i}`}>
                                                <div className="u_flex-align u_mb-10" style={{minHeight: `26px`}} >
                                                    <span className={"u_small-font"}>{item?.name || "-"}</span>
                                                    {item?.status ?
                                                        <React.Fragment>
                                                            <UTags className="u_ib u_ml-15"
                                                                   title={item.statusLocal?.label || '-'}
                                                                   color={item.statusLocal?.color || '-'}/>

                                                            <UPopup params={{className: "u_tooltip u_tooltip-full", on: ['hover']}}
                                                                    desc={<span className='u_text-c'>
                                                                        Note :- {item.statusLocal?.tooltip || ""} <br/>
                                                                        {item.statusLocal?.value !== 1 ? `Reason :- ${item?.reason || ""}` : ""}
                                                                        </span>}>
                                                                <span className="u_cp">
                                                                    <Icon.InfoTooltip fill={COLOR.u_icon_bg} size={16} className="u_mx-10"/>
                                                                </span>
                                                            </UPopup>
                                                        </React.Fragment>
                                                        : ""}
                                                </div>


                                                {!Boolean(item?.[item?.proofId]?.name) ?
                                                    <div className={`u_upload-file u_relative u_p-15 u_flex u_align-center u_content-center u_t-center u_flex-col ${false && 'u_file-error'} ${isDisable ? "u_disabled" : ""}`} style={{minHeight: '110px'}}>
                                                        <label className="u_upload-file-label">
                                                            <input disabled={isDisable} type="file" className="img_file_input" accept="image/*, .doc, .pdf" name={item?.proofId} id={item?.proofId} onChange={e => handle.file(e, item?.proofId)} autoComplete="off"/>
                                                        </label>
                                                        <div className="u_upload-file-inner u_flex u_align-center u_content-center u_t-center u_flex-col">
                                                            <Icon.Upload size={22} fill={COLOR.u_blue}/>
                                                            <p className="u_mt-5 u_small-font u_color-blue">{`Upload ${item?.name}`}</p>
                                                        </div>
                                                    </div> :
                                                    <div className={`u_file-info`} style={{minHeight: `110px`}}>
                                                        <div className="u_file-info-icon">
                                                            <span className="u_m-auto u_text-center">
                                                                <Icon.FilePreview fill={COLOR.u_blue} size={18}/>
                                                                <span className="u_font">{getExtension((item[item?.proofId]?.name)) ?? '-'}</span>
                                                            </span>
                                                            </div>
                                                            <div className="u_file-info-content">
                                                                <p className="u_file-name u_one-line u_mb-5">{showMoreText(item[item?.proofId]?.name || "" , 30) || '-'}</p>
                                                                <div className="u_flex u_align-center"><p className="u_small-font u_mr-10">{item[item?.proofId]?.size ? bytesToSize(item[item?.proofId]?.size) : 0 }</p>
                                                            </div>
                                                        </div>


                                                        {/** DOWNLOAD */}
                                                        { item?.[item?.proofId]  && [1 ,2, 3]?.includes(item?.status) && <div className="u_file-info-action">
                                                            <span className="u_cp u_mx-5">
                                                                   <UFileDownload url={`${_S3_BASE_URL}${item?.file?.url}`} fileName={item?.name} iconSize={16} tooltip="Download"/>
                                                            </span>
                                                        </div>}

                                                        {/** VIEW */}
                                                        { item?.[item?.proofId]  && [1 ,2, 3]?.includes(item?.status) && <div className="u_file-info-action">
                                                                { getFileType(item?.file?.url) === FILE.TYPE.DOCS_ONLY ?<span className="u_cp u_mx-5">
                                                                       <UFileDownload url={`${_S3_BASE_URL}${item?.file?.url}`} fileName={item?.name} iconSize={16} tooltip="View and Download">
                                                                           <Icon.Eye size={16} fill={COLOR.u_icon_bg}/>
                                                                       </UFileDownload>
                                                                </span>
                                                                :<span className="u_cp u_mx-5" onClick={() => setPreviewFile({
                                                                    file: {
                                                                        url: item?.file?.url,
                                                                        fileName: item[item?.proofId]?.name,
                                                                        ext: getExtension(item[item?.proofId]?.name),
                                                                        size: item[item?.proofId]?.size
                                                                    },
                                                                    onDelete: (item?.[item?.proofId] && (![1, 2].includes(item?.status) || props?.isRecruiterSide) && !isDisable)
                                                                        ? () => { handle.removeResume(i, item?.proofId); setPreviewFile(null); }
                                                                        : undefined
                                                                })}>
                                                                    <Icon.Eye size={16} fill={COLOR.u_icon_bg}/>
                                                                </span>}
                                                        </div>}

                                                        {/**DELETE*/}
                                                        { item?.[item?.proofId] && (![1 ,2]?.includes(item?.status) || props?.isRecruiterSide) && <div className={`u_file-info-action`}>
                                                            <UPopup params={{className: "u_tooltip u_tooltip-full", on: ['hover']}} desc={<span className='u_text-c'>Delete</span>}>
                                                                <span className={`u_cp u_mx-5 ${isDisable ? "u_disabled" : ""}`} onClick={() => isDisable ? null : handle.removeResume(i,item?.proofId)}>
                                                                    <Icon.Delete size={16} fill={COLOR.u_icon_bg}/>
                                                                </span>
                                                            </UPopup>
                                                        </div>}
                                                    </div>
                                                }
                                                    {item?.isNumber && <div className="u_mt-16 ">
                                                        <UInput label={`${item?.name ? item?.name + " Number" : ""}`}
                                                                asterisk={(item?.isNumber && !props?.isRecruiterSide)}
                                                                hasError={
                                                                    (() => {
                                                                        if (!props?.isRecruiterSide) {
                                                                            if (item?.isAadharCard) return validator.current.message("aadhaar", item?.value, 'required|aadhaar');
                                                                            else if (item?.isPANCard) return validator.current.message("pan", item?.value, `required|pan`);
                                                                            else if (item?.isPassport) return validator.current.message("passport", item?.value, `required|passport`);
                                                                            else if (item?.isVoterId) return validator.current.message("voterId", item?.value, `required|voterId`);
                                                                            else return validator.current.message(item?.name, item?.value, 'required');
                                                                        } else if (props?.isRecruiterSide) {
                                                                            if (item?.isAadharCard) {
                                                                                return validator.current.message("aadhaar", item?.value, 'aadhaar');
                                                                            } else if (item?.isPANCard) {
                                                                                return validator.current.message("pan", item?.value, `pan`);
                                                                            } else if (item?.isPassport) {
                                                                                return validator.current.message("passport", item?.value, `passport`);
                                                                            } else if (item?.isVoterId) {
                                                                                return validator.current.message("voterId", item?.value, `voterId`);
                                                                            }
                                                                        } else return false;
                                                                    })()
                                                                }>
                                                            <input
                                                                disabled={isDisable ?  true : item.statusLocal?.value === 2}  // Approved Document Number will not be updated
                                                                type={"text"}
                                                                name={item?.name || ""}
                                                                value={item?.value?.toString()}
                                                                placeholder=""
                                                                autoComplete="off"
                                                                onChange={(e) => {
                                                                    if (item?.isAadharCard) {
                                                                        if (/^\d*$/.test(e?.target?.value)) handle?.documentNumber(e, i, 'value')
                                                                    } else handle?.documentNumber(e, i, 'value')
                                                                }
                                                                }/>
                                                        </UInput>
                                                    </div>}
                                                    {item?.isNumber && <div className="u_mt-16 ">
                                                        <UInput label={`Name As Per ${item?.name}`}
                                                                note={"Please enter the same name as on your document."}
                                                                asterisk={!props?.isRecruiterSide}
                                                                hasError={item?.isNumber && validator.current.message("docName", item?.docName, `${!props?.isRecruiterSide ? 'required' : ''}`)}>
                                                            <input
                                                                disabled={isDisable ? true : item.statusLocal?.value === 2}  // Approved Document Number will not be updated
                                                                type={"text"}
                                                                name={item?.docName || ""}
                                                                value={item?.docName?.toString()}
                                                                placeholder=""
                                                                autoComplete="off"
                                                                onChange={(e) => {
                                                                    handle?.documentNumber(e, i, 'docName')
                                                                }
                                                                }/>
                                                        </UInput>
                                                    </div>}
                                            </div>
                                        )
                                    })
                                    :
                                        <div style={{height: "50vh"}} className={"u_w-full"}>
                                            <UNoDataFound className={"u_h-full u_w-full u_m-auto"}  image="/images/no-data-found.svg" message="No data to display"/>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </UCustomScrollBar>
                </div>


                {previewFile && <UFilePreview
                    file={previewFile.file}
                    onClose={() => setPreviewFile(null)}
                    onDelete={previewFile.onDelete}
                />}

                {showThankYou && <CongratulationsModal
                    onClose={handle?.logOut}
                    onSubmit={handle?.logOut}
                    hideCancel={true}
                    hideHeader={true}
                    submitType={"Logout"}
                />}
            </div>
        </React.Fragment>);
};

export default React?.forwardRef(DocumentUpload);
